import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import List from './List'
import { getShops } from '../selectors';
import { standardize } from '../utils/String'

import { nodes, groups } from '../data/data';

import * as listTypes from '../constants/listTypes'
import * as objectTypes from '../constants/objectTypes'

class StoreList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            category: null
        }
    }

    static propTypes = {
        orderBy: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired
    }

    static defaultProps = {
        orderBy: 'seq',
        type: listTypes.ALPHABET
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.type !== this.props.type) {
            this.setState({
                category: null
            })
        }
    }

    handleClick(id, type) {
        if (type === 'group') {
            this.setState({
                category: id
            }, () => {
                if (this.props.onChange) {
                    this.props.onChange()
                }
            })
        } else {
            if (this.props.onClick) {
                this.props.onClick(id)
            }
        }
    }

    handleBackClick() {
        this.setState({
            category: null
        }, () => {
            if (this.props.onChange) {
                this.props.onChange()
            }
        })
    }

    render() {

        const { orderBy, type, shops, groups, filter } = this.props;

        const desc = orderBy === 'popularity';

        // sort stores
        const stores = Object.keys(shops)
                        .filter(key => filter ? shops[key].search.indexOf(standardize(filter)) > -1 : true)
                        .sort((a, b) => desc ? shops[b][orderBy] - shops[a][orderBy] : shops[a][orderBy] - shops[b][orderBy])
                        .map(key => ({...shops[key], children: []}));

        const categories = Object.keys(groups)
                            .sort((a, b) => desc ? groups[b][orderBy] - groups[a][orderBy] : groups[a][orderBy] - groups[b][orderBy])
                            .map(key => ({ ...groups[key]}))

        let items = []

        if (this.state.category !== null) {
            items = groups[this.state.category].children.map(id => shops[id]).filter(item => item)
        } else {
            if (type === listTypes.CATEGORIES) {
                items = categories
            }

            if (type === listTypes.SHOPS) {
                // filter toilet duplicates
                items = stores.filter(item => item.id  !== '36' && item.id !== '263')
                // items = stores
            }

            if (type === listTypes.POPULARITY) {
                // entrance
                ['e1', 'e2', 'e4', 'e3'].forEach(shopId => {
                    const shop = {...shops[shopId]}
                    items.push(shop)
                });

                // top poi
                ['98', '36', '245', '264', '277'].forEach(shopId => {
                    const shop = {...shops[shopId]}
                    items.push(shop)
                });

                // top categories
                const topCategories = categories.slice(0, 2);
                topCategories.forEach(category => category.children = category.children.map(id => shops[id]).filter(item => item))
                items.push(...topCategories);

                // top stores
                items.push(...stores.slice(0, 10))
            }
        }

        return (
            <List
                items={items}
                onClick={::this.handleClick}
                onBackClick={this.state.category !== null ? ::this.handleBackClick : null}
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        shops: getShops(state),
        groups: state.entities.groups
    }
}

export default connect(mapStateToProps)(StoreList);


// WEBPACK FOOTER //
// ./components/StoreList.js